import {TOGGLE_DEV_MODE} from '../mutations/available'


export function toggleDevMode({commit}) {
  commit(TOGGLE_DEV_MODE)
}



// WEBPACK FOOTER //
// ./src/store/actions/dev.js